<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            //
        };
    },
    mounted() {
        this.$api
            .get('/login')
            .then(response => {
                this.$store.set('user', response.data);

                const email = this.$store.get('preferences@email');
                if (!email) {
                    this.$store.set('preferences@email', response.data.email);
                }
            })
            .catch(() => {
                this.$store.set('user', null);
            });
    }
};
</script>
